import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'
import { affiliateData } from '../data/AffiliateData'
import { useTheme } from '../ThemeContext';

export default function DashboardTiles({ setActiveTab }) {
    const navigate = useNavigate()
    const { isDarkMode } = useTheme()

    const [currentDashboard, setCurrentDashboard] = useState('leads')

    const handleFilterLead = (leadStageId) => {
				const isSubAffiliates = currentDashboard === 'leads' ? false : true

        navigate(`/affiliate/leads?page=1&pageSize=100${isSubAffiliates ? '&isSubAffiliates=1' : ''}&leadStageId=${leadStageId}`)
        setActiveTab(isSubAffiliates ? 'subAffiliates' : 'leads')
    }

    const DashboardTile = ({ leadStageId, leadStageName, totalAmount, totalLeads }) => (
        <div onClick={() => handleFilterLead(leadStageId)} className={`cursor-pointer tile flex flex-col justify-between max-sm:w-[90%] lg:w-[98%] lg:h-40 m-1 shadow-full rounded text-xs p-4 font-mont ${isDarkMode ? ' bg-gray-700 hover:bg-gray-800' : 'hover:bg-gray-200'}`}>
            <h2 className={`font-semibold lg:text-base text-sm lg:self-start ${isDarkMode && 'text-white'}`}>{leadStageName === 'Pre-Qualified-N' ? leadStageName + ' (Tax Status Not Completed Yet)' : leadStageName}</h2>
            <p className={`dollarAmount lg:text-2xl font-bold flex justify-start w-full text-base ${isDarkMode && 'text-white'}`}>
                ${totalAmount}
            </p>
            <div className={`totalLeads flex justify-end w-full text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                <p>Total Leads {totalLeads.toLocaleString()}</p>
            </div>
        </div>
    )

    const EstimatedTotalDashboardTile = () => (
        <div onClick={() => handleFilterLead('')} className={`tile cursor-pointer flex flex-col lg:self-start lg:ml-5 max-sm:self-center justify-between max-sm:w-[90%] lg:w-[48%] lg:h-40 m-1 shadow-full rounded text-xs p-4 font-mont ${isDarkMode ? ' bg-gray-700 hover:bg-gray-800' : 'hover:bg-gray-200'}`}>
            <div className='flex flex-row w-[100%] justify-between'>
                <h2 className={`font-semibold lg:text-base text-sm ${isDarkMode && 'text-white'}`}>Total Client Refund</h2>
                <p className={`dollarAmount lg:text-2xl font-bold text-base py-1 ${isDarkMode && 'text-white'}`}>
                    ${currentDashboard === 'leads' ? affiliateData.affiliateDashboardLeadStages.estimatedTotalStage.totalAmount.toLocaleString('en-US', { style: 'decimal', minimumFractionDigits: affiliateData.affiliateDashboardLeadStages.estimatedTotalStage.totalAmount % 1 !== 0 ? 2 : 0 }) : affiliateData.subAffiliatesDashboardLeadStages.estimatedTotalStage.totalAmount.toLocaleString('en-US', { style: 'decimal', minimumFractionDigits: affiliateData.subAffiliatesDashboardLeadStages.estimatedTotalStage.totalAmount % 1 !== 0 ? 2 : 0 })}
                </p>
            </div>
            <div className='tileBottom flex flex-row items-start pt-2'>
                {currentDashboard === 'leads' ? (
                    <div className='tileRight flex flex-col w-1/2'>
                        <div className={`totalLeads flex justify-start text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                            <p>Total Leads {affiliateData.affiliateDashboardLeadStages.estimatedTotalStage.totalLeads.toLocaleString()}</p>
                        </div>
                    </div>
                ) : (
                    <div className='tileRight flex flex-col w-1/2'>
                        <div className={`totalLeads flex justify-start text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                            <p>Sub-Affiliates {affiliateData.subAffiliates.length}</p>
                        </div>
                        <div className={`totalLeads flex justify-start text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                            <p>Sub-Affiliate Leads {affiliateData.subAffiliatesDashboardLeadStages.estimatedTotalStage.totalLeads.toLocaleString()}</p>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )

  return (
		<div className='div lg:w-[90%] mb-10 flex flex-col font-mont gap-10'>
      <div className='w-full flex flex-col items-center'>
        <p className={`self-start lg:text-xl p-5 font-bold max-sm:self-center max-sm:w-full ${isDarkMode && 'text-white'}`}>Total Leads</p>
        <EstimatedTotalDashboardTile />
      </div>
      <div className='flex lg:flex-row max-sm:flex-col items-center'>
				<div className='inline-flex shadow-sm max-sm:mb-5' role='group'>
					<button
						className={`px-4 py-2 text-sm font-medium ${currentDashboard === 'leads' ? 'bg-primaryColor text-white' : `${isDarkMode ? 'bg-gray-700 text-white' : 'bg-gray-200 text-gray-800'}`} rounded-l-lg border border-gray-200`}
						onClick={() => setCurrentDashboard('leads')}
					>
						Your Leads
					</button>
					<button
						className={`px-4 py-2 text-sm font-medium ${currentDashboard === 'subAffiliates' ? 'bg-secondaryColor text-white' : `${isDarkMode ? 'bg-gray-700 text-white' : 'bg-gray-200 text-gray-800'}`} rounded-r-lg border border-gray-200 border-l-0`}
						onClick={() => setCurrentDashboard('subAffiliates')}
					>
						Sub Affiliate Leads
					</button>
				</div>
			</div>
			{currentDashboard === 'leads' ? (
				<div>
					<div className='flex flex-col items-start bg-primaryColor mt-4 mb-4 p-5'>
						<p className='self-start lg:text-xl font-bold max-sm:self-center text-white'>Intake - New Files</p>
						<div className='flex flex-row text-white text-sm mt-2 gap-2'>
							<p>{(affiliateData.affiliateDashboardLeadStages.getTotalIntakeLeadsData().totalLeads).toLocaleString()}</p>
							<p>|</p>
							<p>${(affiliateData.affiliateDashboardLeadStages.getTotalIntakeLeadsData().totalAmount).toLocaleString()}</p>
						</div>
					</div>
						<div className='tiles flex lg:flex-row flex-col items-center gap-4'>
						{affiliateData.affiliateDashboardLeadStages.intakeLeadsStage.map((item, index) => (
							<DashboardTile
								key={index}
								leadStageId={item.leadStageId}
								leadStageName={item.leadStageName}
								totalAmount={item.totalAmount.toLocaleString('en-US', { style: 'decimal', minimumFractionDigits: item.totalAmount % 1 !== 0 ? 2 : 0 })}
								totalLeads={item.totalLeads.toLocaleString()}
							/>
						))}
					</div>
				</div>
			) : (
				<div>
					<div className='flex flex-col items-start bg-primaryColor mt-4 mb-4 p-5'>
						<p className='self-start lg:text-xl font-bold max-sm:self-center text-white'>Intake - New Files</p>
						<div className='flex flex-row text-white text-sm mt-2 gap-2'>
							<p>{(affiliateData.subAffiliatesDashboardLeadStages.getTotalIntakeLeadsData().totalLeads).toLocaleString()}</p>
							<p>|</p>
							<p>${(affiliateData.subAffiliatesDashboardLeadStages.getTotalIntakeLeadsData().totalAmount).toLocaleString()}</p>
						</div>
					</div>
						<div className='tiles flex lg:flex-row flex-col items-center gap-4'>
						{affiliateData.subAffiliatesDashboardLeadStages.intakeLeadsStage.map((item, index) => (
							<DashboardTile
								key={index}
								leadStageId={item.leadStageId}
								leadStageName={item.leadStageName}
								totalAmount={item.totalAmount.toLocaleString('en-US', { style: 'decimal', minimumFractionDigits: item.totalAmount % 1 !== 0 ? 2 : 0 })}
								totalLeads={item.totalLeads.toLocaleString()}
							/>
						))}
					</div>
				</div>
			)}
      <div className='grid grid-cols-1 lg:grid-cols-3 lg:gap-4'>
        <div className='flex lg:flex-row flex-col justify-center lg:gap-4'>
					{currentDashboard === 'leads' ? (
						<div>
							<div className='flex flex-col items-start bg-primaryColor mt-4 mb-4 p-5'>
								<p className='self-start lg:text-xl font-bold max-sm:self-center text-white'>Pre-Paid Files</p>
								<div className='flex flex-row text-white text-sm mt-2 gap-2'>
									<p>{(affiliateData.affiliateDashboardLeadStages.getTotalPrePaidLeadsData().totalLeads).toLocaleString()}</p>
									<p>|</p>
									<p>${(affiliateData.affiliateDashboardLeadStages.getTotalPrePaidLeadsData().totalAmount).toLocaleString()}</p>
								</div>
							</div>
							<div className='tiles flex flex-col items-center lg:grid lg:grid-cols-1 gap-4'>
								{affiliateData.affiliateDashboardLeadStages.prePaidLeadsStage.map((item, index) => (
									<DashboardTile
										key={index}
										leadStageId={item.leadStageId}
										leadStageName={item.leadStageName}
										totalAmount={item.totalAmount.toLocaleString('en-US', { style: 'decimal', minimumFractionDigits: item.totalAmount % 1 !== 0 ? 2 : 0 })}
										totalLeads={item.totalLeads.toLocaleString()}
									/>
								))}
							</div>
						</div>
					) : (
						<div>
							<div className='flex flex-col items-start bg-primaryColor mt-4 mb-4 p-5'>
								<p className='self-start lg:text-xl font-bold max-sm:self-center text-white'>Pre-Paid Files</p>
								<div className='flex flex-row text-white text-sm mt-2 gap-2'>
									<p>{(affiliateData.subAffiliatesDashboardLeadStages.getTotalPrePaidLeadsData().totalLeads).toLocaleString()}</p>
									<p>|</p>
									<p>${(affiliateData.subAffiliatesDashboardLeadStages.getTotalPrePaidLeadsData().totalAmount).toLocaleString()}</p>
								</div>
							</div>
							<div className='tiles flex flex-col items-center lg:grid lg:grid-cols-1 gap-4'>
								{affiliateData.subAffiliatesDashboardLeadStages.prePaidLeadsStage.map((item, index) => (
									<DashboardTile
										key={index}
										leadStageId={item.leadStageId}
										leadStageName={item.leadStageName}
										totalAmount={item.totalAmount.toLocaleString('en-US', { style: 'decimal', minimumFractionDigits: item.totalAmount % 1 !== 0 ? 2 : 0 })}
										totalLeads={item.totalLeads.toLocaleString()}
									/>
								))}
							</div>
						</div>
					)}
          {currentDashboard === 'leads' ? (
						<div>
							<div className='flex flex-col items-start bg-secondaryColor mt-4 mb-4 p-5'>
								<p className='self-start lg:text-xl font-bold max-sm:self-center text-white'>Post-Paid Files</p>
								<div className='flex flex-row text-white text-sm mt-2 gap-2'>
									<p>{(affiliateData.affiliateDashboardLeadStages.getTotalPostPaidLeadsData().totalLeads).toLocaleString()}</p>
									<p>|</p>
									<p>${(affiliateData.affiliateDashboardLeadStages.getTotalPostPaidLeadsData().totalAmount).toLocaleString()}</p>
								</div>
							</div>
							<div className='tiles flex flex-col items-center lg:grid lg:grid-cols-1 gap-4'>
								{affiliateData.affiliateDashboardLeadStages.postPaidLeadsStage.map((item, index) => (
									<DashboardTile
										key={index}
										leadStageId={item.leadStageId}
										leadStageName={item.leadStageName}
										totalAmount={item.totalAmount.toLocaleString('en-US', { style: 'decimal', minimumFractionDigits: item.totalAmount % 1 !== 0 ? 2 : 0 })}
										totalLeads={item.totalLeads.toLocaleString()}
									/>
								))}
							</div>
						</div>
					) : (
						<div>
							<div className='flex flex-col items-start bg-secondaryColor mt-4 mb-4 p-5'>
								<p className='self-start lg:text-xl font-bold max-sm:self-center text-white'>Post-Paid Files</p>
								<div className='flex flex-row text-white text-sm mt-2 gap-2'>
									<p>{(affiliateData.subAffiliatesDashboardLeadStages.getTotalPostPaidLeadsData().totalLeads).toLocaleString()}</p>
									<p>|</p>
									<p>${(affiliateData.subAffiliatesDashboardLeadStages.getTotalPostPaidLeadsData().totalAmount).toLocaleString()}</p>
								</div>
							</div>
							<div className='tiles flex flex-col items-center lg:grid lg:grid-cols-1 gap-4'>
								{affiliateData.subAffiliatesDashboardLeadStages.postPaidLeadsStage.map((item, index) => (
									<DashboardTile
										key={index}
										leadStageId={item.leadStageId}
										leadStageName={item.leadStageName}
										totalAmount={item.totalAmount.toLocaleString('en-US', { style: 'decimal', minimumFractionDigits: item.totalAmount % 1 !== 0 ? 2 : 0 })}
										totalLeads={item.totalLeads.toLocaleString()}
									/>
								))}
							</div>
						</div>
					)}
        </div>
        {currentDashboard === 'leads' ? (
					<div className='lg:col-span-2'>
						<div className='flex flex-col items-start bg-primaryColor mt-4 mb-4 p-5'>
							<p className='self-start lg:text-xl font-bold max-sm:self-center text-white'>Advance Funding Files</p>
							<div className='flex flex-row text-white text-sm mt-2 gap-2'>
								<p>{(affiliateData.affiliateDashboardLeadStages.getTotalAdvanceFundingData().totalLeads).toLocaleString()}</p>
								<p>|</p>
								<p>${(affiliateData.affiliateDashboardLeadStages.getTotalAdvanceFundingData().totalAmount).toLocaleString()}</p>
							</div>
						</div>
						<div className='tiles flex flex-col items-center lg:grid lg:grid-cols-4 gap-4'>
							{affiliateData.affiliateDashboardLeadStages.advanceFundingStage.map((item, index) => (
								<DashboardTile
									key={index}
									leadStageId={item.leadStageId}
									leadStageName={item.leadStageName}
									totalAmount={item.totalAmount.toLocaleString('en-US', { style: 'decimal', minimumFractionDigits: item.totalAmount % 1 !== 0 ? 2 : 0 })}
									totalLeads={item.totalLeads.toLocaleString()}
								/>
							))}
						</div>
					</div>
				) : (
					<div className='lg:col-span-2'>
						<div className='flex flex-col items-start bg-primaryColor mt-4 mb-4 p-5'>
							<p className='self-start lg:text-xl font-bold max-sm:self-center text-white'>Advance Funding Files</p>
							<div className='flex flex-row text-white text-sm mt-2 gap-2'>
								<p>{(affiliateData.subAffiliatesDashboardLeadStages.getTotalAdvanceFundingData().totalLeads).toLocaleString()}</p>
								<p>|</p>
								<p>${(affiliateData.subAffiliatesDashboardLeadStages.getTotalAdvanceFundingData().totalAmount).toLocaleString()}</p>
							</div>
						</div>
						<div className='tiles flex flex-col items-center lg:grid lg:grid-cols-4 gap-4'>
							{affiliateData.subAffiliatesDashboardLeadStages.advanceFundingStage.map((item, index) => (
								<DashboardTile
									key={index}
									leadStageId={item.leadStageId}
									leadStageName={item.leadStageName}
									totalAmount={item.totalAmount.toLocaleString('en-US', { style: 'decimal', minimumFractionDigits: item.totalAmount % 1 !== 0 ? 2 : 0 })}
									totalLeads={item.totalLeads.toLocaleString()}
								/>
							))}
						</div>
					</div>
				)}
        {currentDashboard === 'leads' ? (
					<div>
						<div className='flex flex-col items-start bg-secondaryColor mt-4 mb-4 p-5'>
							<p className='self-start lg:text-xl font-bold max-sm:self-center text-white'>Not Qualified / Not Interested</p>
							<div className='flex flex-row text-white text-sm mt-2 gap-2'>
								<p>{(affiliateData.affiliateDashboardLeadStages.getTotalNotQualifiedLeadsData().totalLeads).toLocaleString()}</p>
								<p>|</p>
								<p>${(affiliateData.affiliateDashboardLeadStages.getTotalNotQualifiedLeadsData().totalAmount).toLocaleString()}</p>
							</div>
						</div>
						<div className='tiles flex flex-col items-center lg:grid lg:grid-cols-2 gap-4'>
							{affiliateData.affiliateDashboardLeadStages.notQualifiedLeadsStage.map((item, index) => (
								<DashboardTile
									key={index}
									leadStageId={item.leadStageId}
									leadStageName={item.leadStageName}
									totalAmount={item.totalAmount.toLocaleString('en-US', { style: 'decimal', minimumFractionDigits: item.totalAmount % 1 !== 0 ? 2 : 0 })}
									totalLeads={item.totalLeads.toLocaleString()}
								/>
							))}
						</div>
					</div>
				) : (
					<div>
						<div className='flex flex-col items-start bg-secondaryColor mt-4 mb-4 p-5'>
							<p className='self-start lg:text-xl font-bold max-sm:self-center text-white'>Not Qualified / Not Interested</p>
							<div className='flex flex-row text-white text-sm mt-2 gap-2'>
								<p>{(affiliateData.subAffiliatesDashboardLeadStages.getTotalNotQualifiedLeadsData().totalLeads).toLocaleString()}</p>
								<p>|</p>
								<p>${(affiliateData.subAffiliatesDashboardLeadStages.getTotalNotQualifiedLeadsData().totalAmount).toLocaleString()}</p>
							</div>
						</div>
						<div className='tiles flex flex-col items-center lg:grid lg:grid-cols-2 gap-4'>
							{affiliateData.subAffiliatesDashboardLeadStages.notQualifiedLeadsStage.map((item, index) => (
								<DashboardTile
									key={index}
									leadStageId={item.leadStageId}
									leadStageName={item.leadStageName}
									totalAmount={item.totalAmount.toLocaleString('en-US', { style: 'decimal', minimumFractionDigits: item.totalAmount % 1 !== 0 ? 2 : 0 })}
									totalLeads={item.totalLeads.toLocaleString()}
								/>
							))}
						</div>
					</div>
				)}
				{currentDashboard === 'leads' ? (
					<div>
						<div className='flex flex-col items-start bg-primaryColor mt-4 mb-4 p-5'>
							<p className='self-start lg:text-xl font-bold max-sm:self-center text-white'>Files with Issues</p>
							<div className='flex flex-row text-white text-sm mt-2 gap-2'>
								<p>{(affiliateData.affiliateDashboardLeadStages.getTotalIssueLeadsData().totalLeads).toLocaleString()}</p>
								<p>|</p>
								<p>${(affiliateData.affiliateDashboardLeadStages.getTotalIssueLeadsData().totalAmount).toLocaleString()}</p>
							</div>
						</div>
						<div className='tiles flex flex-col items-center lg:grid lg:grid-cols-2 gap-4'>
							{affiliateData.affiliateDashboardLeadStages.issueLeadsStage.map((item, index) => (
								<DashboardTile
									key={index}
									leadStageId={item.leadStageId}
									leadStageName={item.leadStageName}
									totalAmount={item.totalAmount.toLocaleString('en-US', { style: 'decimal', minimumFractionDigits: item.totalAmount % 1 !== 0 ? 2 : 0 })}
									totalLeads={item.totalLeads.toLocaleString()}
								/>
							))}
						</div>
					</div>
				) : (
					<div>
						<div className='flex flex-col items-start bg-primaryColor mt-4 mb-4 p-5'>
							<p className='self-start lg:text-xl font-bold max-sm:self-center text-white'>Files with Issues</p>
							<div className='flex flex-row text-white text-sm mt-2 gap-2'>
								<p>{(affiliateData.subAffiliatesDashboardLeadStages.getTotalIssueLeadsData().totalLeads).toLocaleString()}</p>
								<p>|</p>
								<p>${(affiliateData.subAffiliatesDashboardLeadStages.getTotalIssueLeadsData().totalAmount).toLocaleString()}</p>
							</div>
						</div>
						<div className='tiles flex flex-col items-center lg:grid lg:grid-cols-2 gap-4'>
							{affiliateData.subAffiliatesDashboardLeadStages.issueLeadsStage.map((item, index) => (
								<DashboardTile
									key={index}
									leadStageId={item.leadStageId}
									leadStageName={item.leadStageName}
									totalAmount={item.totalAmount.toLocaleString('en-US', { style: 'decimal', minimumFractionDigits: item.totalAmount % 1 !== 0 ? 2 : 0 })}
									totalLeads={item.totalLeads.toLocaleString()}
								/>
							))}
						</div>
					</div>
				)}
        {currentDashboard === 'leads' ? (
					<div>
						<div className='flex flex-col items-start bg-secondaryColor mt-4 mb-4 p-5'>
							<p className='self-start lg:text-xl font-bold max-sm:self-center text-white'>Completed Files</p>
							<div className='flex flex-row text-white text-sm mt-2 gap-2'>
								<p>{(affiliateData.affiliateDashboardLeadStages.getTotalCompletedLeadsData().totalLeads).toLocaleString()}</p>
								<p>|</p>
								<p>${(affiliateData.affiliateDashboardLeadStages.getTotalCompletedLeadsData().totalAmount).toLocaleString()}</p>
							</div>
						</div>
						<div className='tiles flex flex-col items-center lg:grid lg:grid-cols-2 gap-4'>
							{affiliateData.affiliateDashboardLeadStages.completedLeadsStage.map((item, index) => (
								<DashboardTile
									key={index}
									leadStageId={item.leadStageId}
									leadStageName={item.leadStageName}
									totalAmount={item.totalAmount.toLocaleString('en-US', { style: 'decimal', minimumFractionDigits: item.totalAmount % 1 !== 0 ? 2 : 0 })}
									totalLeads={item.totalLeads.toLocaleString()}
								/>
							))}
						</div>
					</div>
				) : (
					<div>
						<div className='flex flex-col items-start bg-secondaryColor mt-4 mb-4 p-5'>
							<p className='self-start lg:text-xl font-bold max-sm:self-center text-white'>Completed Files</p>
							<div className='flex flex-row text-white text-sm mt-2 gap-2'>
								<p>{(affiliateData.subAffiliatesDashboardLeadStages.getTotalCompletedLeadsData().totalLeads).toLocaleString()}</p>
								<p>|</p>
								<p>${(affiliateData.subAffiliatesDashboardLeadStages.getTotalCompletedLeadsData().totalAmount).toLocaleString()}</p>
							</div>
						</div>
						<div className='tiles flex flex-col items-center lg:grid lg:grid-cols-2 gap-4'>
							{affiliateData.subAffiliatesDashboardLeadStages.completedLeadsStage.map((item, index) => (
								<DashboardTile
									key={index}
									leadStageId={item.leadStageId}
									leadStageName={item.leadStageName}
									totalAmount={item.totalAmount.toLocaleString('en-US', { style: 'decimal', minimumFractionDigits: item.totalAmount % 1 !== 0 ? 2 : 0 })}
									totalLeads={item.totalLeads.toLocaleString()}
								/>
							))}
						</div>
					</div>
				)}
      </div>
    </div>
  )
}